import { gql } from 'graphql.macro';

export const getLabMaterialsTemplate = gql`
    query labMaterials(
        $filters: MaterialFilters
        $offset: Int
        $limit: Int
        $orderBy: MaterialOrderBy
        $orderDirection: OrderDirection
    ) {
        labMaterials(
            filters: $filters
            offset: $offset
            limit: $limit
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            _id
            materialCode
            description
            vat
            addedDate
            inactive
            inactivatedDate
            batchInventoryManagement
            batches {
                batchNumber
                quantity
                fullBatchQuantity
                createdOn
                closed
                closedDate
            }
        }
    }
`;

export const getMaterialPriceListsTemplate = gql`
    query materialPriceLists($filters: MaterialFilters, $offset: Int, $limit: Int) {
        materialPriceLists(filters: $filters, offset: $offset, limit: $limit) {
            _id
            currency
            materialPriceListName
            isStandardPriceList
            materialListType
            conversionRate
            conversionCurrency
            materials {
                _id
                material
                materialCode
                description
                addedDate
                basePrice
                originalPrice
            }
        }
    }
`;
